import React, { useState } from 'react';
import { API } from './App';

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  background: '#161616',
  border: '0.5px solid #2a2a2a',
  borderRadius: 8,
  color: '#f0ede8',
  fontSize: 13,
  fontFamily: "'DM Sans', sans-serif",
  boxSizing: 'border-box',
  outline: 'none'
};

const labelStyle = {
  display: 'block',
  fontSize: 11,
  color: '#666',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: 6
};

export default function NewPayment({ shopId, getToken }) {
  const [form, setForm] = useState({
    roNumber: '', customerName: '', customerEmail: '',
    customerPhone: '', amount: '', paymentMethod: 'terminal'
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const validate = () => {
    if (!form.roNumber.trim()) return 'RO Number is required.';
    if (!form.customerName.trim()) return 'Customer Name is required.';
    if (form.customerEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.customerEmail)) {
      return 'Customer Email is not valid.';
    }
    if (!form.customerEmail.trim() && !form.customerPhone.trim()) {
      return 'Either Customer Email or Customer Phone is required.';
    }
    const amount = parseFloat(form.amount);
    if (!form.amount.trim() || isNaN(amount) || amount <= 0) {
      return 'Amount must be a number greater than 0.';
    }
    return null;
  };

  const handleSubmit = async () => {
    if (!shopId) {
      setStatus({ success: false, message: 'No shop associated with your account.' });
      return;
    }
    const validationError = validate();
    if (validationError) {
      setStatus({ success: false, message: validationError });
      return;
    }
    setLoading(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/payments`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ shopId, userId: null, ...form, amount: parseFloat(form.amount) }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Request failed');
      setStatus({ success: true, message: `Payment created! ID: ${data.paymentId}` });
      setForm({ roNumber: '', customerName: '', customerEmail: '', customerPhone: '', amount: '', paymentMethod: 'terminal' });
    } catch (err) {
      setStatus({ success: false, message: err.message || 'Error creating payment.' });
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <div style={{ fontSize: 11, color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 20 }}>New Payment</div>

      {status && (
        <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 20, fontSize: 13, background: status.success ? '#1a3a2a' : '#3a1a1a', color: status.success ? '#4ade80' : '#f87171' }}>
          {status.message}
        </div>
      )}

      <div style={{ background: '#161616', border: '0.5px solid #2a2a2a', borderRadius: 12, padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        {[
          { label: 'RO Number', name: 'roNumber', placeholder: 'e.g. RO-4821' },
          { label: 'Customer Name', name: 'customerName', placeholder: 'Full name' },
          { label: 'Customer Email', name: 'customerEmail', placeholder: 'email@example.com' },
          { label: 'Customer Phone', name: 'customerPhone', placeholder: '555-0100' },
          { label: 'Amount ($)', name: 'amount', placeholder: '0.00' },
        ].map(f => (
          <div key={f.name}>
            <label style={labelStyle}>{f.label}</label>
            <input name={f.name} value={form[f.name]} onChange={handleChange} placeholder={f.placeholder} style={inputStyle} />
          </div>
        ))}

        <div>
          <label style={labelStyle}>Payment Method</label>
          <select name="paymentMethod" value={form.paymentMethod} onChange={handleChange} style={{ ...inputStyle, cursor: 'pointer' }}>
            <option value="terminal">Terminal</option>
            <option value="text">Text to Pay</option>
            <option value="email">Email to Pay</option>
          </select>
        </div>

        <button onClick={handleSubmit} disabled={loading}
          style={{ background: loading ? '#1a3a2a' : '#4ade80', color: '#0f0f0f', border: 'none', borderRadius: 8, padding: '12px', fontSize: 13, fontWeight: 600, fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', marginTop: 4 }}>
          {loading ? 'Creating...' : 'Create Payment'}
        </button>
      </div>
    </div>
  );
}
